import { Fragment, useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import _ from 'lodash';
import { useLocation, useParams } from 'react-router';

import { QRCode } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import { dateToJalali, getAppUrl } from '../../../Utils/Helpers';
import { IDCardContext } from '../Context/IDCardContext';

const PrintIDCard = () => {
  const { id } = useParams();
  const { get } = useApi();
  const { error } = useToast();
  const { state } = useLocation();
  const context = useContext(IDCardContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      await getCompetition();
    };
    getData();
  }, [id]);

  useEffect(() => {
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    document.onkeydown = (e) => {
      // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
      if (
        e.keyCode === 123 ||
        ctrlShiftKey(e, 'I') ||
        ctrlShiftKey(e, 'J') ||
        ctrlShiftKey(e, 'C') ||
        (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
      )
        return false;
    };
  }, []);
  const ctrlShiftKey = (e, keyCode) => {
    return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
  };

  const getCompetition = async () => {
    setLoading(true);
    await get(
      `/competition/${id}`,
      (res) => {
        context.competition = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت مسابقه با خطا مواجه شد.');
        setLoading(false);
      },
    );
  };

  //   const getWeight = (user) => {
  //     const { usersRegister } = state;
  //     let userFind = usersRegister?.find((u) => u.id == user?.id);
  //     return userFind?.weight?.weight;
  //   };
  //   const getSport = (user) => {
  //     const { usersRegister } = state;
  //     let userFind = usersRegister?.find((u) => u.id == user?.id);
  //     return userFind?.sport?.map((s) => s?.title + ' ');
  //   };

  const getUsers = () => {
    return context?.competition?.agents?.filter((a) => {
      if (state?.users?.includes(a.user.id)) {
        return a;
      }
    });
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <div style={{ width: '21cm', height: '29.7cm' }} id='print-area'>
          <div className='d-flex flex-row flex-wrap justify-content-center w-100'>
            {getUsers()?.map((user) => (
              <Fragment key={user?.id}>
                <div
                  className=' border borer-dark rounded mx-2 my-2'
                  style={{
                    position: 'relative',
                    width: context?.competition?.IDCard?.width + 'cm',
                    height: context?.competition?.IDCard?.height,
                  }}
                >
                  <img
                    src={context?.competition?.IDCard?.background_image}
                    alt=''
                    style={{
                      width: context?.competition?.IDCard?.width + 'cm',

                      height: context?.competition?.IDCard?.height + 'cm',
                    }}
                  />
                  {context?.competition?.IDCard?.fields?.map((field) => (
                    <Fragment key={field?.id}>
                      {field?.type === 'string' ? (
                        <div className='align-items-center'>
                          <span
                            className='text-dark'
                            style={{
                              fontSize:
                                context?.competition?.IDCard?.font_size + 'px',
                              position: 'absolute',
                              top: field?.top + 'px',
                              bottom: field?.bottom + 'px',
                              right: field?.right + 'px',
                              left: field?.left + 'px',
                              fontFamily: field?.bold ? 'iranBold' : 'iransans',
                            }}
                          >
                            {field?.name === 'insurnce'
                              ? user?.insurance?.end_date
                              : field?.name == 'weight'
                              ? '-'
                              : field?.name == 'field'
                              ? '-'
                              : field?.name == 'sid'
                              ? user?.agent_side
                              : field?.name == 'competition_name'
                              ? context?.competition?.title
                              : field?.name == 'competition_province_id'
                              ? context?.competition?.province?.name
                              : field?.name == 'now'
                              ? moment().locale('fa').format('Y/M/D')
                              : field?.name == 'sku'
                              ? context?.competition?.sku
                              : field?.name == 'full_name'
                              ? user?.name + ' ' + user?.last_name
                              : field?.name == 'end_at'
                              ? dateToJalali(context?.competition?.end_at)
                              : user?.[field?.name]}
                          </span>
                        </div>
                      ) : field?.type === 'QRCode' ? (
                        <div
                          className='align-items-center'
                          style={{
                            width:
                              field?.width != undefined ? field?.width : 100,
                            height:
                              field?.height != undefined ? field?.height : 100,
                            position: 'absolute',
                            top: field?.top + 'px',
                            bottom: field?.bottom + 'px',
                            right: field?.right + 'px',
                            left: field?.left + 'px',
                          }}
                        >
                          <QRCode
                            width={
                              field?.width != undefined ? field?.width : 100
                            }
                            height={
                              field?.height != undefined ? field?.height : 100
                            }
                            value={`${getAppUrl()}/id-card/competition/${
                              context.competition?.id
                            }/user/${user?.id}`}
                          />
                        </div>
                      ) : field?.type === 'image' ? (
                        <div
                          style={{
                            position: 'absolute',
                            top: field?.top + 'px',
                            right: field?.right + 'px',
                            left: field?.left + 'px',
                            bottom: field?.bottom + 'px',
                            width: field?.width + 'px',
                            height: field?.height + 'px',
                          }}
                        >
                          <img
                            className='font-weight-bold w-100 h-100 rounded'
                            style={{
                              backgroundSize: 'contain',
                            }}
                            src={user?.[field?.name]}
                            alt=''
                          />
                        </div>
                      ) : field?.type === 'date' ? (
                        <div className='align-items-center'>
                          <span
                            className='text-dark'
                            style={{
                              fontSize:
                                context?.competition?.IDCard?.font_size + 'px',
                              position: 'absolute',
                              top: field?.top + 'px',
                              bottom: field?.bottom + 'px',
                              right: field?.right + 'px',
                              left: field?.left + 'px',
                              fontFamily: field?.bold ? 'iranBold' : 'iransans',
                            }}
                          >
                            {dateToJalali(user?.[field?.name])}
                          </span>
                        </div>
                      ) : field?.type === 'province' ? (
                        <div className='align-items-center'>
                          <span
                            className='text-dark'
                            style={{
                              fontSize:
                                context?.competition?.IDCard?.font_size + 'px',
                              position: 'absolute',
                              top: field?.top + 'px',
                              bottom: field?.bottom + 'px',
                              right: field?.right + 'px',
                              left: field?.left + 'px',
                              fontFamily: field?.bold ? 'iranBold' : 'iransans',
                            }}
                          >
                            {user?.[field?.name]?.name}
                          </span>
                        </div>
                      ) : null}
                    </Fragment>
                  ))}
                  {!_.isEmpty(context.competition?.IDCard?.signature) ? (
                    <div className='d-flex flex-column selectDisable'>
                      <img
                        className='selectDisable'
                        src={
                          context.competition?.IDCard?.signature
                            ?.background_image ?? ''
                        }
                        style={{
                          width:
                            context.competition?.IDCard?.signature?.width +
                            'px',
                          height:
                            context.competition?.IDCard?.signature?.height +
                            'px',
                          position: 'absolute',
                          top:
                            context.competition?.IDCard?.signature?.top + 'px',
                          right:
                            context.competition?.IDCard?.signature?.right +
                            'px',
                          left:
                            context.competition?.IDCard?.signature?.left + 'px',
                          bottom:
                            context.competition?.IDCard?.signature?.bottom +
                            'px',
                        }}
                        alt=''
                      />
                    </div>
                  ) : null}
                </div>
              </Fragment>
            ))}
          </div>
        </div>
      </div>
      <div
        className='w-100 d-flex flex-row justify-content-end'
        style={{ position: 'fixed', bottom: '5px', left: '10px' }}
      >
        <button
          onClick={(e) => {
            window.print();
          }}
          className='btn btn-info w-10 my-5 print'
        >
          ذخیره
        </button>
      </div>
    </>
  );
};

export default PrintIDCard;
